// extracted by mini-css-extract-plugin
module.exports = {"container":"impact-figure_container__N3axe"};